<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="TRANSLATION CENTER LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
      @clickClearBtn="handleClickClearBtn"
    >
      <template v-slot:fileName="{ tableRow }">
        <a
          href="javascript:void (0)"
          style="margin-right: 20px"
          @click="handleDownload(tableRow.row.fileUrl, tableRow.row.fileName)"
        >
          {{ tableRow.row.fileName }}
        </a>
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          v-show="tableRow.row.translatedFileUrl"
          style="margin-right: 20px"
          @click="
            handleDownload(
              tableRow.row.translatedFileUrl,
              'financial report.doc',
            )
          "
        >
          financial report.doc
        </a>
        <a
          href="javascript:void (0)"
          v-show="tableRow.row.parsedFileUrl"
          @click="
            handleDownload(tableRow.row.parsedFileUrl, 'translateGo.xlsx')
          "
        >
          translateGo.xlsx
        </a>
      </template>
      <template v-slot:vagueSearch>
        <el-form-item label="Submitted By">
          <el-select
            v-model="submitUserId"
            style="width: 300px"
            filterable
            remote
            placeholder="please select"
            :remote-method="queryName"
            clearable
          >
            <el-option
              v-for="name in nameOptions"
              :key="name.id"
              :label="name.username"
              :value="name.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </table-view>
    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="560px"
      @close="handleCancel"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="File Type" prop="fileType">
            <el-select v-model="form.fileType" filterable style="width: 100%">
              <el-option label="Financial Report" :value="1" />
              <el-option label="Other" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="File Language" prop="fileLanguage">
            <el-select
              filterable
              v-model="form.fileLanguage"
              style="width: 100%"
            >
              <el-option
                v-for="item in fileLanguageList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Target Language" prop="targetLanguage">
            <el-select
              filterable
              v-model="form.targetLanguage"
              style="width: 100%"
            >
              <el-option label="Chinese" value="zh" />
              <el-option label="English" value="en" />
            </el-select>
          </el-form-item>
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :show-file-list="false"
            :on-change="handleChange"
            :file-list="fileList"
            :on-success="handleUploadSuccess"
          >
            <customize-button style="width: 100%">Upload</customize-button>
          </el-upload>
          <ul class="upload-list">
            <li v-for="item in fileList" :key="item.uid" :title="item.name">
              {{ item.name }}
            </li>
          </ul>
          <el-form-item label="Pages" prop="spliter">
            <el-input v-model="form.spliter" style="width: 100%"></el-input>
          </el-form-item>
          <p style="line-height: 20px">
            Continous pages represented by page range, e.g. 1-3 stands for page
            1,2,3.
          </p>
          <p style="line-height: 20px">
            Uncontinuous page seperated by comma, e.g. 1,3,5 stands for page
            1,3,5
          </p>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button
          class="clear-btn"
          style="margin-right: 20px"
          @click="handleCancel"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, getAssign, add, download } from './api'
import { getSelectList } from '@/api'
import config from '@/config'
import { ERR_OK } from '@/utils/request'

export default {
  data() {
    const searchModel = [
      {
        label: 'Original File',
        type: 'input',
        key: 'fileName',
      },
      {
        label: 'Create Time',
        type: 'time',
        key: 'time',
        defaultValue: [],
      },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          {
            id: 0,
            name: 'Init',
          },
          {
            id: 1,
            name: 'Translating',
          },
          {
            id: 7,
            name: 'Translating Failed',
          },
          {
            id: 2,
            name: 'Translation Success',
          },
          {
            id: 3,
            name: 'Translation Failed',
          },
          {
            id: 5,
            name: 'Parsing Success',
          },
          {
            id: 6,
            name: 'Parsing Failed',
          },
        ],
      },
    ]
    const tableModel = [
      {
        label: 'Original File',
        prop: 'fileName',
        slotName: 'fileName',
      },
      {
        label: 'File Type',
        prop: 'fileTypeStr',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'Submitted By',
        prop: 'submittedBy',
      },
      {
        label: 'Status',
        prop: 'statusStr',
      },
      {
        label: 'Doc.',
        width: 280,
        slotName: 'action',
      },
    ]
    return {
      uploadUrl: `${config.baseApi}/customer-api/file/upload`,
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      submitUserId: '',
      assignLoading: false,
      nameOptions: [],
      form: {
        fileType: '',
        fileLanguage: '',
        targetLanguage: 'en',
        fileUrl: '',
        fileName: '',
        spliter: '',
      },
      rules: {
        fileType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        fileLanguage: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        targetLanguage: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        spliter: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      fileLanguageList: [],
      fileList: [],
    }
  },
  mounted() {
    this.initTable()
    this._getSelectList()
  },
  methods: {
    handleClickClearBtn() {
      this.submitUserId = ''
      this.nameOptions = []
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const submitData = { ...params }

        submitData.createTimeBegin = submitData.startTime
        submitData.createTimeEnd = submitData.endTime
        delete submitData.startTime
        delete submitData.endTime
        submitData.submitUserId = this.submitUserId

        const { data, page } = await getTableData(submitData)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    queryName(query) {
      this._getAssign(query)
    },
    async _getAssign(query) {
      try {
        this.nameOptions = await getAssign(query)
      } catch (err) {
        console.log(err)
      }
    },
    handleCancel() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    async handleTitleActionBtn() {
      this.visible = true
    },
    async handleSaveBtn() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          if (this.form.fileUrl) {
            await add(this.form)
            this.initTable()
            this.visible = false
            this.$message.success('success')
          } else {
            this.$message.warning('Please upload the file')
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleUploadSuccess({ code, msg, data }) {
      if (code === ERR_OK) {
        this.form.fileUrl = data.url
        this.form.fileName = data.name
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.fileList.pop()
      }
    },
    handleChange(file) {
      if (!file.response) {
        this.fileList.splice(0, 1, file)
      }
    },
    async _getSelectList() {
      try {
        this.fileLanguageList = await getSelectList('TranslationLanguage')
      } catch (err) {
        console.error(err)
      }
    },
    async handleDownload(url, fileName) {
      try {
        await download({ url, fileName })
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
